module.exports = __webpack_public_path__ + "img/shoulder width.506bbf6f.png";